import Swal from 'sweetalert2';
import {
  failureGenerateLocationId,
  failureMerchantAdd,
  failureMerchantDeactivate,
  failureMerchantDelete,
  failureMerchantList,
  failureMerchantListPage,
  failureMerchantView,
  failureSyncDataMerchant,
  failureSyncMerchantSheet,
  requestGenerateLocationId,
  requestMerchantAdd,
  requestMerchantDeactivate,
  requestMerchantDelete,
  requestMerchantList,
  requestMerchantListPage,
  requestMerchantView,
  requestSyncDataMerchant,
  requestSyncMerchantSheet,
  responseGenerateLocationId,
  responseMerchantAdd,
  responseMerchantDeactivate,
  responseMerchantDelete,
  responseMerchantList,
  responseMerchantListPage,
  responseMerchantView,
  responseSyncDataMerchant,
  requestTemporaryClose,
  responseTemporaryClose,
  failureTemporaryClose,
  requestMaintenanceMode,
  responseMaintenanceMode,
  failureMaintenanceMode,
  requestComingSoonMode,
  responseComingSoonMode,
  failureComingSoonMode,
  responseSyncMerchantSheet,
  requestBulkHide,
  responseBulkHide,
  failureBulkHide,
  requestArchiveMerchant,
  responseArchiveMerchant,
  failureArchiveMerchant,
} from '../../slices/merchantSlice/merchantSlice';
import {
  MERCHANT,
  MERCHANTDEACTIVATE,
  MERCHANT_MAINTENANCE,
  MERCHANT_TEMPORARY_CLOSE,
  MERCHANT_COMING_SOON,
  MERCHANT_BULK_HIDE,
  MERCHANT_ARCHIVE,
  MERCHANTLIST,
  MERCHANT_WITH_STATION_COUNT,
  SYNCDATAMERCHANT,
  LOCATION_GENERATE,
  SYNC_MERCHANT_SHEET,
} from '../../../utils/StaticApiEndpoints';
import requestApi from 'utils/Request';

/////////// Call this function inside Modal of selecting merchnat data ////
export const ListMerchantData = (payload) => async (dispatch) => {
  try {
    dispatch(requestMerchantList());
    const res = await requestApi.get(MERCHANTLIST, { params: payload });
    dispatch(responseMerchantList(res));
  } catch (error) {
    Swal.fire({
      icon: 'error',
      text: error?.message,
    });
    dispatch(failureMerchantList(error?.message));
  }
};

///////// call this function in marchant list page ////
export const MerchantDataListPage = (payload) => async (dispatch) => {
  try {
    dispatch(requestMerchantListPage());
    const res = await requestApi.get(MERCHANTLIST, { params: payload });
    dispatch(responseMerchantListPage(res));
  } catch (error) {
    Swal.fire({
      icon: 'error',
      text: error?.message,
    });
    dispatch(failureMerchantListPage(error?.message));
  }
};

export const AddMerchantData = (payload, callback) => async (dispatch) => {
  try {
    dispatch(requestMerchantAdd());
    const res = await requestApi.post(MERCHANT, payload);
    dispatch(responseMerchantAdd(res));
    if (typeof callback === 'function') {
      callback();
    }
  } catch (error) {
    Swal.fire({
      icon: 'error',
      text: error?.message,
    });
    dispatch(failureMerchantAdd(error?.message));
  }
};

////// detail merchant /////
export const ViewMerchantData = (payload) => async (dispatch) => {
  try {
    dispatch(requestMerchantView());
    const { data } = await requestApi.get(
      `${MERCHANT}/${payload?.id}`,
      payload,
    );
    dispatch(responseMerchantView(data));
  } catch (error) {
    Swal.fire({
      icon: 'error',
      text: error?.message,
    });
    dispatch(failureMerchantView(error?.message));
  }
};

////// Generate location id //////
export const GetLocationId = (payload, callback) => async (dispatch) => {
  try {
    dispatch(requestGenerateLocationId());
    const { data } = await requestApi.post(`${LOCATION_GENERATE}`, payload);
    dispatch(responseGenerateLocationId(data));
    if (typeof callback === 'function') {
      callback(data);
    }
  } catch (error) {
    Swal.fire({
      icon: 'error',
      text: error?.message,
    });
    dispatch(failureGenerateLocationId(error?.message));
  }
};

/////// edit merchnat ///
export const EditMerchantData =
  (id, loader, payload, callback) => async (dispatch) => {
    try {
      dispatch(requestMerchantAdd(loader));
      const res = await requestApi.put(`${MERCHANT}/${id}`, payload);
      dispatch(responseMerchantAdd(res));
      if (typeof callback === 'function') {
        callback();
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        text: error?.message,
      });
      dispatch(failureMerchantAdd(error?.message));
    }
  };

export const MaintenanceMode = (id, payload, callback) => async (dispatch) => {
  try {
    dispatch(requestMaintenanceMode());
    const res = await requestApi.put(`${MERCHANT_MAINTENANCE}/${id}`, payload);
    dispatch(responseMaintenanceMode(res));
    if (typeof callback === 'function') {
      callback();
    }
  } catch (error) {
    Swal.fire({
      icon: 'error',
      text: error?.message,
    });
    dispatch(failureMaintenanceMode(error?.message));
  }
};
export const TemporaryCloseMerchant =
  (id, payload, callback) => async (dispatch) => {
    try {
      dispatch(requestTemporaryClose());
      const res = await requestApi.put(
        `${MERCHANT_TEMPORARY_CLOSE}/${id}`,
        payload,
      );
      dispatch(responseTemporaryClose(res));
      if (typeof callback === 'function') {
        callback();
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        text: error?.message,
      });
      dispatch(failureTemporaryClose(error?.message));
    }
  };

export const ComingSoonMode = (id, payload, callback) => async (dispatch) => {
  try {
    dispatch(requestComingSoonMode());
    const res = await requestApi.put(`${MERCHANT_COMING_SOON}/${id}`, payload);
    dispatch(responseComingSoonMode(res));
    if (typeof callback === 'function') {
      callback();
    }
  } catch (error) {
    Swal.fire({
      icon: 'error',
      text: error?.message,
    });
    dispatch(failureComingSoonMode(error?.message));
  }
};

///// bulk hide/restore merchants ///
export const BulkHideMerchants = (payload, callback) => async (dispatch) => {
  try {
    dispatch(requestBulkHide());
    await requestApi.put(MERCHANT_BULK_HIDE, payload);
    dispatch(responseBulkHide());
    if (typeof callback === 'function') {
      callback();
    }
  } catch (error) {
    Swal.fire({
      icon: 'error',
      text: error?.message,
    });
    dispatch(failureBulkHide(error?.message));
  }
};

///// archive / restore single merchant ///
export const ArchiveMerchant = (id, payload, callback) => async (dispatch) => {
  try {
    dispatch(requestArchiveMerchant());
    await requestApi.put(`${MERCHANT_ARCHIVE}/${id}`, payload);
    dispatch(responseArchiveMerchant());
    if (typeof callback === 'function') {
      callback();
    }
  } catch (error) {
    Swal.fire({
      icon: 'error',
      text: error?.message,
    });
    dispatch(failureArchiveMerchant(error?.message));
  }
};

///// delete merchant ///
export const DeleteMerchnatData =
  (id, payload, callback) => async (dispatch) => {
    try {
      dispatch(requestMerchantDelete());
      const res = await requestApi.delete(`${MERCHANT}/${id}`, payload);
      dispatch(responseMerchantDelete(res));
      if (typeof callback === 'function') {
        callback();
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        text: error?.message,
      });
      dispatch(failureMerchantDelete(error?.message));
    }
  };

export const SyncDataMerchant = (callback) => async (dispatch) => {
  try {
    dispatch(requestSyncDataMerchant());
    const response = await requestApi.get(`${SYNCDATAMERCHANT}`);
    dispatch(responseSyncDataMerchant(response));
    Swal.fire({
      icon: 'success',
      text: response.message,
    }).then(() => callback());
  } catch (error) {
    Swal.fire({
      icon: 'error',
      text: error?.message,
    });
    dispatch(failureSyncDataMerchant(error?.message));
  }
};

/////////// Merchant deactivate-Active /////
export const MerchantDeactivateActive =
  (id, payload, callback) => async (dispatch) => {
    try {
      dispatch(requestMerchantDeactivate());
      const res = await requestApi.put(`${MERCHANTDEACTIVATE}/${id}`, payload);
      dispatch(responseMerchantDeactivate(res));
      if (typeof callback === 'function') {
        callback();
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        text: error?.message,
      });
      dispatch(failureMerchantDeactivate(error?.message));
    }
  };

/////////// Sync Merchant Data to Google Sheet ////
export const SyncMerchantSheet = (callback) => async (dispatch) => {
  try {
    dispatch(requestSyncMerchantSheet());
    const response = await requestApi.post(SYNC_MERCHANT_SHEET);
    dispatch(responseSyncMerchantSheet(response));
    Swal.fire({
      icon: 'success',
      text: response.message,
    }).then(() => {
      if (typeof callback === 'function') callback();
    });
  } catch (error) {
    Swal.fire({
      icon: 'error',
      text: error?.message,
    });
    dispatch(failureSyncMerchantSheet(error?.message));
  }
};

/////////// Merchant list with station count for exclusion filter ///////
export const ListMerchantsWithStationCount =
  (payload, callback) => async (dispatch) => {
    try {
      dispatch(requestMerchantList());
      const res = await requestApi.get(MERCHANT_WITH_STATION_COUNT, {
        params: payload,
      });
      dispatch(responseMerchantList(res));
      if (typeof callback === 'function') {
        callback(res);
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        text: error?.message,
      });
      dispatch(failureMerchantList(error?.message));
    }
  };
